const IS_CLIENT = typeof window !== 'undefined';
export default IS_CLIENT;
//# sourceMappingURL=isClient.js.map